import { useMemo } from "react";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { getMenuLanguages } from "../../constants/menuLanguages";
import { persistChosenLanguage } from "../../i18n";
import "./login-language-switcher.css";

export default function LoginLanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const menuLanguages = useMemo(() => getMenuLanguages(t), [t]);
  const langCode = String(i18n.language || "en").split("-")[0].toLowerCase();
  const currentLang =
    menuLanguages.find((lang) => lang.code === langCode) || menuLanguages[0];

  const changeLanguage = (code) => {
    i18n.changeLanguage(code);
    persistChosenLanguage(code);
  };

  return (
    <div className="login-language-switcher">
      <Dropdown align="start">
        <Dropdown.Toggle
          variant="light"
          id="login-language-dropdown"
          className="login-language-switcher__toggle"
        >
          <img
            src={currentLang.flag}
            alt=""
            width={20}
            height={20}
            className="login-language-switcher__flag"
          />
          <span className="login-language-switcher__label">{currentLang.label}</span>
          <i className="fa-solid fa-chevron-down login-language-switcher__chevron" />
        </Dropdown.Toggle>
        <Dropdown.Menu
          className="login-language-switcher__menu"
          popperConfig={{ strategy: "fixed" }}
        >
          {menuLanguages.map((lang) => (
            <Dropdown.Item
              key={lang.code}
              active={lang.code === langCode}
              onClick={() => changeLanguage(lang.code)}
              className="login-language-switcher__item"
            >
              <img
                src={lang.flag}
                alt=""
                width={20}
                height={20}
                className="login-language-switcher__flag"
              />
              <span>{lang.label}</span>
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}
